import React, { FunctionComponent, ReactNode } from 'react';
import Labels from 'enums/Labels';
import Language from 'enums/Language';
import { injectDangerousHTML, translate } from 'utils/utils';

type Props = {
  label?: Labels;
  lang?: Language;
  trustedLabel?: string;
  isRequired?: boolean;
  children?: ReactNode;
};

// TODO: Maybe rename to something more descriptive.
// You can now have a Label component in a <label/> element.
const Label: FunctionComponent<Props> = ({
  trustedLabel,
  label,
  lang,
  isRequired,
  children,
}) => {
  let comp: React.ReactElement | null = null;

  if (label) {
    if (!lang) throw new Error('Missing "lang" prop on Label component');

    comp = (
      <p>
        {translate(label, lang)}
        { children }
        {isRequired ? <span className="required-input">*</span> : null}
      </p>
    );
  } else if (trustedLabel) {
    comp = (
      <p>
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={injectDangerousHTML(trustedLabel)} />
        { children }
      </p>
    );
  }

  return comp;
};

export default Label;
